















































import Vue from 'vue';
import { OpenHelp } from '@/mixins';
import SettingWrapper from '../setting-wrapper.component.vue';
import { ExtendMixins } from '@/services';

export default ExtendMixins(
  OpenHelp,
).extend({
  name: 'PersonalSettings',
  computed: {
    bankAccountsCount(): number {
      return this.$store.getters.bankAccountQuantity;
    },
    bankAccountsCountLabel(): string {
      return this.bankAccountsCount === 1
        ? this.$options.filters.t([
            'personal-settings_label_bank-account',
            'global_bank-account',
          ])
        : this.$options.filters.t([
            'personal-settings_label_bank-accounts',
            'global_bank-accounts',
          ]);
    },
    providersCount(): number {
      return this.$store.getters.providersQuantity;
    },
    providersCountLabel(): string {
      return this.providersCount === 1
        ? this.$options.filters.t([
            'personal-settings_label_provider',
            'global_provider',
          ])
        : this.$options.filters.t([
            'personal-settings_label_providers',
            'global_providers',
          ]);
    },
    ariDesigneesCount(): number {
      return this.$store.getters.ariDesigneesQuantity;
    },
    ariDesigneesCountLabel(): string {
      return this.ariDesigneesCount === 1
        ? this.$options.filters.t([
            'personal-settings_label_ari-designee',
            'global_ari-designee',
          ])
        : this.$options.filters.t([
            'personal-settings_label_ari-designees',
            'global_ari-designees',
          ]);
    },
  },
  components: {
    SettingWrapper,
  },
});
